<div class="container {{ OBJ_LNG_NAME }}">
    <h1 mat-dialog-title>
        {{ subject}}
    </h1>
    <mat-dialog-content>
        <p>{{ question }}</p>
    </mat-dialog-content>
    <mat-dialog-actions align="end">
        <button mat-raised-button [mat-dialog-close]>{{ 'allgemein.nein' | translate:locale.language }}</button>
        <button mat-raised-button color="primary" [mat-dialog-close]="true">{{ 'allgemein.ja' | translate:locale.language }}</button>
    </mat-dialog-actions>
</div>